import { render } from "./SpecialCharsButtons.vue?vue&type=template&id=19f80656&scoped=true"
import script from "./SpecialCharsButtons.vue?vue&type=script&lang=js"
export * from "./SpecialCharsButtons.vue?vue&type=script&lang=js"

import "./SpecialCharsButtons.vue?vue&type=style&index=0&id=19f80656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f80656"]])

export default __exports__